import {
	ApartmentCreate,
	ApartmentEdit,
	ApartmentExternalPage,
	ApartmentShow,
	ApartmentsList
} from './sections/apartments';
import {
	BuildingCreate,
	BuildingEdit,
	BuildingShow,
	BuildingsList
} from './sections/buildings';
import {
	CommerceCreate,
	CommerceEdit,
	CommerceShow,
	CommercesList
} from './sections/commerces';
import {
	ComplexCreate,
	ComplexEdit,
	ComplexesList,
	ComplexShow
} from './sections/complexes';
import {
	OfficeCreate,
	OfficeEdit,
	OfficeShow,
	OfficesList
} from './sections/offices';
import { OBJECTS_TYPES } from './constants';
import { MainPage } from './MainPage';

export * from './types';
export * from './constants';

export const components = {
	mainPage: MainPage,
	apartmentsList: ApartmentsList,
	commercesList: CommercesList,
	complexesList: ComplexesList,
	officesList: OfficesList,
	buildingsList: BuildingsList
};

export const objectsCreateRoutes = [
	{
		route: `objects/${OBJECTS_TYPES.APARTMENTS}/create`,
		element: ApartmentCreate
	},
	{
		route: `objects/${OBJECTS_TYPES.OFFICES}/create`,
		element: OfficeCreate
	},
	{
		route: `objects/${OBJECTS_TYPES.BUILDINGS}/create`,
		element: BuildingCreate
	},
	{
		route: `objects/${OBJECTS_TYPES.COMMERCES}/create`,
		element: CommerceCreate
	},
	{
		route: `objects/${OBJECTS_TYPES.COMPLEXES}/create`,
		element: ComplexCreate
	}
];

export const objectExternalPagesRoutes = [
	{
		route: `/apartment/show-page/:id`,
		element: ApartmentExternalPage
	}
];

export const objectsShowRoutes = [
	{
		route: `objects/${OBJECTS_TYPES.APARTMENTS}/show/:id`,
		element: ApartmentShow
	},
	{
		route: `objects/${OBJECTS_TYPES.COMMERCES}/show/:id`,
		element: CommerceShow
	},
	{
		route: `objects/${OBJECTS_TYPES.COMPLEXES}/show/:id`,
		element: ComplexShow
	},
	{
		route: `objects/${OBJECTS_TYPES.OFFICES}/show/:id`,
		element: OfficeShow
	},
	{
		route: `objects/${OBJECTS_TYPES.BUILDINGS}/show/:id`,
		element: BuildingShow
	}
];

export const objectsEditRoutes = [
	{
		route: `objects/${OBJECTS_TYPES.APARTMENTS}/edit/:id`,
		element: ApartmentEdit
	},
	{
		route: `objects/${OBJECTS_TYPES.COMMERCES}/edit/:id`,
		element: CommerceEdit
	},
	{
		route: `objects/${OBJECTS_TYPES.COMPLEXES}/edit/:id`,
		element: ComplexEdit
	},
	{
		route: `objects/${OBJECTS_TYPES.OFFICES}/edit/:id`,
		element: OfficeEdit
	},
	{
		route: `objects/${OBJECTS_TYPES.BUILDINGS}/edit/:id`,
		element: BuildingEdit
	}
];
